.avatar {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  overflow: hidden;
  border-radius: var(--radius-md);
  background: var(--color-card-hover);
  color: var(--color-foreground);
  font-weight: 700;
  line-height: 1;
}

.circle {
  border-radius: 9999px;
}

.size-extra-small {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: var(--radius-sm);
  font-size: 0.625rem;
}

.size-small {
  width: 2rem;
  height: 2rem;
  font-size: var(--text-sm);
}

.size-medium {
  width: 2.5rem;
  height: 2.5rem;
  font-size: var(--text-base);
}

.size-large {
  width: 3rem;
  height: 3rem;
  font-size: var(--text-lg);
  font-weight: 800;
}

/* Organisations are square and projects round, at every size (see `kind`). */
.organisation {
  border-radius: calc(var(--radius-sm) / 2);
  box-shadow: inset 0 0 0 1px var(--color-border);
}

.project {
  border-radius: 9999px;
  box-shadow: inset 0 0 0 1px var(--color-border);
}
